/* eslint-disable */

import {
  makeStyles,
  RACCheckBox,
  RACCOLOR,
  RACRowTip,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACDateTimeLabel
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next'; // Import i18next
import { CancelTokenSource } from 'axios';
import clsx from 'clsx';
import React, { useContext, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { getCancelTokenSource } from '../../../api/client';
import { getAgreementInfo, getPastDueList } from '../../../api/Customer';
import {
  ApiStateWrapper,
  Loader,
} from '../../../common/ApiStateWrapper/ApiStateWrapper';
import { AppRoute } from '../../../config/route-config';
import {
  ALL_OPTION,
  INITIAL_OFFSET,
  WORKED_HISTORY_ACTIVITY_TYPE_CODES,
  WORKED_HISTORY_CALL_RESULT_CODES,
  WORKED_HISTORY_COMMITMENT_STATUS_CODES,
} from '../../../constants/constants';
import {
  PastDueListCustomerDispatchStateContext,
  PastDueListCustomerStateContext,
} from '../../../context/PastDueListCustomer/PastDueListCustomerProvider';
import { useFilters } from '../../../context/PastDueListSearchCriteria/PastDueListSearchCriteriaProvider';
import { getRowColor } from '../../../context/WorkedHistory/WorkedHistoryProvider';
import { Filter } from '../../../domain/PastDueList/Filter';
import {
  Commitment,
  CustomerBalanceInfo,
  getFilterByLabel,
  PastDueCustomerResponse,
  PastDueListStatusLegend,
} from '../../../domain/PastDueList/PastDueCustomerList';
import { formatDateString, getSelectedStore } from '../../../utils/utils';
import { CommitmentNotesModal } from '../../Customer/History/CommitmentNotesModal';
import {
  usePriorityFieldCustomerActions,
  usePriorityFieldCustomerState,
} from '../../../context/PriorityFieldVisit/PriorityFieldProvider';
import { ReactComponent as PriorityIcon } from './../../../assets/img/pp2.svg';
import {
  StoreDetailResponse,
  ScheduleFieldVisitDTO,
} from '../../../types/types';
import { getStoreDetailByNumber } from '../../../api/store';
import { useStoreDetails } from '../../../context/Store/StoreProvider';

export const customerListWrapperTestId = 'customerListWrapperTestId';

const useClasses = makeStyles((theme: any) => ({
  customerListWrapper: {
    overflowX: 'auto',
    height: theme.typography.pxToRem(500),
  },
  header: {
    fontSize: '1rem',
    marginBottom: '.5rem',
  },
  cardBody: {
    padding: '.5rem',
    width: '100%',
    boxSizing: 'border-box',
  },
  checkbox: {
    padding: '0',
  },
  noLeftPadding: {
    paddingLeft: 0,
  },
  selected: {
    backgroundColor: 'none !important',
  },
  leftPadding21: {
    paddingLeft: theme.typography.pxToRem(21),
  },
  iconSize: {
    width: '20px',
    height: '20px',
  },
  paddingTopBottom8: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
  },
  link: {
    color: RACCOLOR.BLUE_CRAYOLA,
    cursor: 'pointer',
  },
  contentHeight: {
    height: theme.typography.pxToRem(500),
  },
  tipRoot: {
    borderLeftWidth: theme.typography.pxToRem(6),
  },
}));

const applySubFilter = (
  pastDue: PastDueCustomerResponse[] | undefined,
  subFilter: string
) => {
  let filteredPastDueList: PastDueCustomerResponse[] | undefined = pastDue && [
    ...pastDue,
  ];

  if (pastDue && subFilter) {
    const filterName = getFilterByLabel(subFilter) as PastDueListStatusLegend;
    const { CALL_CUSTOMER, COMMITMENT, TEXT_RECEIVED, TEXT_SENT } =
      WORKED_HISTORY_ACTIVITY_TYPE_CODES;

    const { LMAL, LMCE, LMWK, LMR1, LMR2, LMR3, LMR4, NO_ANSWER } =
      WORKED_HISTORY_CALL_RESULT_CODES;

    const { BROKEN } = WORKED_HISTORY_COMMITMENT_STATUS_CODES;

    switch (filterName) {
      case PastDueListStatusLegend.FirstPaymentDefault:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) => pastDueItem.firstPaymentDefault.toUpperCase() === 'Y'
        );
        break;
      case PastDueListStatusLegend.SecondPaymentDefault:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem.secondPaymentDefault.toUpperCase() === 'Y'
        );
        break;
      case PastDueListStatusLegend.BrokenCommitment:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem?.accountActivityType?.code === COMMITMENT &&
            pastDueItem?.commitment?.commitmentStatus?.code === BROKEN
        );
        break;
      case PastDueListStatusLegend.Commitment:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem?.accountActivityType?.code === COMMITMENT &&
            pastDueItem?.commitment?.commitmentStatus?.code !== BROKEN
        );
        break;
      case PastDueListStatusLegend.LeftMessage:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem?.accountActivityType?.code === CALL_CUSTOMER &&
            [LMAL, LMCE, LMWK, LMR1, LMR2, LMR3, LMR4].includes(
              pastDueItem?.callResultType
                ?.code as WORKED_HISTORY_CALL_RESULT_CODES
            )
        );
        break;
      case PastDueListStatusLegend.NoContact:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem?.accountActivityType?.code === CALL_CUSTOMER &&
            pastDueItem?.callResultType?.code === NO_ANSWER
        );
        break;
      case PastDueListStatusLegend.TextReceived:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) =>
            pastDueItem?.accountActivityType?.code === TEXT_RECEIVED
        );
        break;
      case PastDueListStatusLegend.TextSent:
        filteredPastDueList = pastDue.filter(
          (pastDueItem) => pastDueItem?.accountActivityType?.code === TEXT_SENT
        );
        break;
    }
  }
  return filteredPastDueList;
};

export const getCustomerFullName = (
  firstName: string,
  lastName: string,
  isFirstPaymentDefault: string,
  isSecondPaymentDefault: string
) => {
  const fullName = `${lastName} ${firstName}`;

  if (isFirstPaymentDefault?.toUpperCase() === 'Y') {
    return `*${fullName}`;
  }

  if (isSecondPaymentDefault?.toUpperCase() === 'Y') {
    return `**${fullName}`;
  }

  return fullName;
};

export const getCustomerInfoFullName = (
  firstName: string,
  lastName: string,
  isFirstPaymentDefault: string,
  isSecondPaymentDefault: string
) => {
  const fullName = `${firstName} ${lastName}`;

  if (isFirstPaymentDefault?.toUpperCase() === 'Y') {
    return `*${fullName}`;
  }

  if (isSecondPaymentDefault?.toUpperCase() === 'Y') {
    return `**${fullName}`;
  }

  return fullName;
};

const validateFieldValue = (value: string) => (value ? value : '-');

export const getNSFChargebackAmt = (customerBalance: CustomerBalanceInfo[]) => {
  const customerBalanceForSelectedStore = customerBalance?.filter(
    (custBalanceItem) =>
      custBalanceItem?.type === 'NSFCCCB' &&
      custBalanceItem?.storeNumber === getSelectedStore()
  );
  return customerBalanceForSelectedStore[0]?.amount;
};

export const CustomerList = () => {
  const { t } = useTranslation();
  const initialCallToken = useRef<CancelTokenSource>();
  const [offset, setOffset] = useState<number>(INITIAL_OFFSET);
  const [isFirstFetch, setIsFirstFetch] = useState<boolean>(true);

  const { enableFieldVisitStrategy, store, DateTimeLocalization, pastDueListApiLimit, storeConfigLoaded } = useStoreDetails();

  const classes = useClasses();
  const { filter } = useFilters();
  const {
    pastDue,
    scheduleFieldVisitDto,
    selectedCustomerIds,
    filter: subFilter,
    loading,
    hasMore,
    reloadPastDueList,
  } = useContext(PastDueListCustomerStateContext);

  const [selected, setSelected] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [filterName, setFilterName] = useState<string>('');
  const [hasApiError, setHasApiError] = useState<boolean>(false);
  const [filteredPastDue, setFilteredPastdue] = useState<
    PastDueCustomerResponse[]
  >([]);
  const [isCommitmentNotesModalOpen, setIsCommitmentNotesModalOpen] =
    useState(false);
  const [selectedCommitment, setSelectedCommitment] =
    useState<Commitment | null>();
  const isPastDueListEmpty = !filteredPastDue || filteredPastDue?.length === 0;

  const {
    onCustomerSelectChanged,
    setSelectCustomerName,
    setFilteredPastDueList,
    setSelectedCustomerIds,
    buildFieldVisitXferList,
    setPastDueListLoading,
    clearPastDueList,
    setReloadPastDueList,
  } = useContext(PastDueListCustomerDispatchStateContext);

  const { priorityFieldVisitCustomerDetails } = usePriorityFieldCustomerState();
  const { fetchPriorityCustomerDetails } = usePriorityFieldCustomerActions();

  const isCustomerPriority = (customerId: string): boolean => {
    const foundIt = priorityFieldVisitCustomerDetails.find(
      (oneCustomer) => oneCustomer.customer.customerId == customerId
    );

    return foundIt ? true : false;
  };
  const { isMXAccountManagement } = useStoreDetails();
  const tableHeaderList = [
    '',
    "Customer's Name",
    'Days Past Due',
    'Route',
    'Worked',
    'Due Date',
    'Commitment',
    'Active Agr.',
    'My Store Agr',
    'AP',
    ...(isMXAccountManagement ? ['NSF/CCCB $'] : []),
    'Letter',
    '# Contacts Total',
    '# Contacts Today',
  ];

  useEffect(() => {
    async function fetchData() {
      let storeId = '99999';
      const storeNumber = window.sessionStorage.getItem('storeNumber');

      if (storeNumber) {
        const details: StoreDetailResponse = await getStoreDetailByNumber(
          storeNumber
        );
        details.response.forEach((oneResp) => {
          if (oneResp?.storeNumber == storeNumber) {
            storeId = oneResp?.storeId;
          }
        });
      }
      fetchPriorityCustomerDetails(storeId);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const handleSelectAllClick = (event: any) => {
  //   if (pastDue) {
  //     setSelectCustomerName('');
  //     if (event.target.checked) {
  //       const newSelectedItems = filteredPastDue?.map((n) => n.customerId);
  //       if (newSelectedItems) {
  //         setSelected(newSelectedItems);

  //         onCustomerSelectChanged(true);
  //         setSelectedCustomerIds(newSelectedItems);
  //       }
  //       return;
  //     }
  //     onCustomerSelectChanged(false);

  //     setSelected([]);
  //     setSelectedCustomerIds([]);
  //   }
  // };
  const toggleSelectAll = async () => {
    setSelectAll(!selectAll);
    const newSelected: string[] = [];
    const oneJump: ScheduleFieldVisitDTO[] = [];
    if (!selectAll) {
      pastDue?.forEach(async (oneCustomer: PastDueCustomerResponse) => {
        newSelected.push(oneCustomer.customerId);
        const agmNum = await determineAgreementNumber(oneCustomer.customerId);
        if (agmNum) {
          oneJump.push({
            name:
              oneCustomer.customerFirstName +
              ' ' +
              oneCustomer.customerLastName,
            customerId: oneCustomer.customerId,
            agreementNumber: agmNum,
          });
        }
      });
    }

    buildFieldVisitXferList(oneJump);

    setSelected(newSelected);

    onCustomerSelectChanged(true);
    setSelectedCustomerIds(newSelected);
  };

  const handleCommitmentNotesModalClose = () => {
    setIsCommitmentNotesModalOpen(false);
    setSelectedCommitment(null);
  };

  const determineAgreementNumber = async (custId: any): Promise<string> => {
    if (custId) {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      const custDtl = await getAgreementInfo(custId);
      for (let idx = 0; idx < custDtl?.stores?.length; idx++) {
        for (
          let inner = 0;
          custDtl.stores[idx].agreements &&
          inner < custDtl.stores[idx].agreements?.length;
          inner++
        ) {
          if (
            storeNumber == custDtl.stores[idx].storeNumber &&
            custDtl.stores[idx].agreements[inner].agreementNumber
          )
            return custDtl.stores[idx].agreements[inner].agreementNumber;
        }
      }
    }

    return '';
  };

  const findCustomerInList = (
    customerId: string
  ): PastDueCustomerResponse | undefined => {
    if (pastDue) {
      return pastDue.find((one) => one.customerId == customerId);
    }
  };
  const handleRowSelectionChange = async (item: string) => {
    let newSelected: string[] = [];
    let oneJump: ScheduleFieldVisitDTO[] = scheduleFieldVisitDto;

    const oneCustomer = findCustomerInList(item);

    if (selected.includes(item)) {
      newSelected = selected.filter((selectedItem) => selectedItem !== item);
      oneJump = oneJump.filter(
        (selectedItem) => selectedItem.customerId !== item
      );
    } else {
      newSelected = newSelected.concat(selected, item);
      if (oneCustomer) {
        const agmNum = await determineAgreementNumber(oneCustomer.customerId);
        oneJump.push({
          name:
            oneCustomer.customerFirstName + ' ' + oneCustomer.customerLastName,
          customerId: oneCustomer.customerId,
          agreementNumber: agmNum,
        });
      }
    }

    buildFieldVisitXferList(oneJump);
    setSelected(newSelected);
    setSelectCustomerName('');

    if (newSelected.length > 0) {
      onCustomerSelectChanged(true);
      if (newSelected.length == 1) {
        setSelectCustomerName(findSelectedName(newSelected[0]));
      }
    } else {
      onCustomerSelectChanged(false);
    }
    setSelectedCustomerIds(newSelected);
  };

  const findSelectedName = (itemSelected: string) => {
    const selectedCustomer = filteredPastDue?.find(
      (pastDueCustomer) => pastDueCustomer.customerId === itemSelected
    );
    if (!selectedCustomer) return '';

    return getCustomerFullName(
      selectedCustomer.customerFirstName,
      selectedCustomer.customerLastName,
      selectedCustomer.firstPaymentDefault,
      selectedCustomer.secondPaymentDefault
    );
  };

  const isSelected = (selectedItems: string[], item: string) =>
    selectedItems.includes(item);

  const renderTableHead = () => (
    <>
      {tableHeaderList.map((col, index) => {
        if (enableFieldVisitStrategy && index === 0) {
          return (
            <RACTableCell
              key={index}
              padding="checkbox"
              classes={{
                root: clsx(classes.leftPadding21, classes.paddingTopBottom8),
              }}
            >
              <RACCheckBox
                id="999"
                color="primary"
                onChange={async () => await toggleSelectAll()}
                checked={selectAll}
                classes={{ checkbox: classes.checkbox }}
              />
            </RACTableCell>
          );
        } else if (index === 0) {
          return (
            !isPastDueListEmpty && (
              <RACTableCell
                key={index}
                padding="checkbox"
                classes={{
                  root: clsx(classes.leftPadding21, classes.paddingTopBottom8),
                }}
              >
                {/* Currently removed, because API supports only 8 items
                
                <RACCheckBox
                  color="primary"
                  indeterminate={
                    filteredPastDue &&
                    selected.length > 0 &&
                    selected.length < filteredPastDue.length
                  }
                  checked={
                    filteredPastDue &&
                    filteredPastDue.length > 0 &&
                    selected.length === filteredPastDue.length
                  }
                  onChange={handleSelectAllClick}
                  classes={{ checkbox: classes.checkbox }}
                /> */}
              </RACTableCell>
            )
          );
        } else {
          return (
            <RACTableCell
              key={index}
              classes={{
                root: classes.paddingTopBottom8,
              }}
            >
              {t(col)}
            </RACTableCell>
          );
        }
      })}
    </>
  );

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const renderTableContentFilled = () => (
    <>
      {filteredPastDue?.map((pastDueCustomer, index) => {
        const commitmentStatusCode =
          pastDueCustomer.commitment?.commitmentStatus?.code;
        const hasCommitment =
          pastDueCustomer.accountActivityType?.code?.toUpperCase() === 'CMT';
        const commitment: string | undefined = hasCommitment
          ? pastDueCustomer.commitment?.commitmentStatus?.description
          : '';
        const isCommitmentBrokenOrOpen =
          (hasCommitment &&
            commitmentStatusCode ===
              WORKED_HISTORY_COMMITMENT_STATUS_CODES.OPEN) ||
          commitmentStatusCode ===
            WORKED_HISTORY_COMMITMENT_STATUS_CODES.BROKEN;
        const showCommitmentAsLink = commitment && isCommitmentBrokenOrOpen;
        const NSFChargebackAmt = pastDueCustomer?.customerBalance
          ? getNSFChargebackAmt(pastDueCustomer?.customerBalance)
          : '';
        const commitmentFieldValue = validateFieldValue(commitment);
        return (
          <RACTableRow
            key={pastDueCustomer.customerId}
            selected={isSelected(selected, pastDueCustomer.customerId)}
            hover
            backgroundColor={
              getRowColor(
                pastDueCustomer?.accountActivityType?.code,
                pastDueCustomer?.callResultType?.code,
                pastDueCustomer?.commitment?.commitmentStatus?.code
              ).row
            }
            classes={{ selected: classes.selected }}
          >
            <>
              <RACTableCell>
                <RACRowTip
                  classes={{ root: classes.tipRoot }}
                  tipColor={
                    getRowColor(
                      pastDueCustomer?.accountActivityType?.code,
                      pastDueCustomer?.callResultType?.code,
                      pastDueCustomer?.commitment?.commitmentStatus?.code
                    ).tip
                  }
                />
                <RACCheckBox
                  id={pastDueCustomer.customerId}
                  color="primary"
                  onChange={async () =>
                    await handleRowSelectionChange(pastDueCustomer.customerId)
                  }
                  checked={isSelected(
                    selectedCustomerIds,
                    pastDueCustomer.customerId
                  )}
                  classes={{ checkbox: classes.checkbox }}
                />
              </RACTableCell>
              <RACTableCell classes={{ root: classes.link }}>
                <Link
                  style={{ color: 'inherit', textDecoration: 'unset' }}
                  to={{
                    pathname: `${AppRoute.Customer}/${pastDueCustomer.customerId}`,
                    state: {
                      customer: pastDueCustomer,
                      customerIndex: index,
                    },
                  }}
                >
                  {getCustomerFullName(
                    pastDueCustomer.customerFirstName,
                    pastDueCustomer.customerLastName,
                    pastDueCustomer.firstPaymentDefault,
                    pastDueCustomer.secondPaymentDefault
                  )}
                  {isCustomerPriority(pastDueCustomer.customerId) ? (
                    <PriorityIcon className={`${classes.iconSize} `} />
                  ) : null}
                </Link>
              </RACTableCell>
              <RACTableCell>{pastDueCustomer.daysPastDue}</RACTableCell>
              <RACTableCell>
                {i18n.t(pastDueCustomer.route?.description)}
              </RACTableCell>
              <RACTableCell>
                {pastDueCustomer.accountActivityType?.code?.toUpperCase() ===
                  'TXTS' ||
                pastDueCustomer.accountActivityType?.code?.toUpperCase() ===
                  'TXTR' ||
                pastDueCustomer.accountActivityType?.code?.toUpperCase() ===
                  'LP' ||
                pastDueCustomer.accountActivityType?.code?.toUpperCase() ===
                  'CMT' ||
                pastDueCustomer.accountActivityType?.code?.toUpperCase() ===
                  'TXTSF'
                  ? i18n.t(pastDueCustomer.accountActivityType?.description)
                  : ['CALLC', 'CALLA', 'CALLR', 'CALLE'].includes(
                      pastDueCustomer.accountActivityType?.code?.toUpperCase()
                    )
                  ? i18n.t(pastDueCustomer.callResultType?.description)
                  : '-'}
              </RACTableCell>
              <RACTableCell>
                {DateTimeLocalization ? 
                <RACDateTimeLabel 
                  value={pastDueCustomer.pastDueDate} 
                  country={store?.countryAbb} 
                  displayType ={'ShortDate'}
                /> : 
                formatDateString(pastDueCustomer.pastDueDate) }
              </RACTableCell>
              <RACTableCell classes={{ root: classes.link }}>
                {showCommitmentAsLink ? (
                  <span
                    onClick={() => {
                      setSelectedCommitment(pastDueCustomer.commitment);
                      setIsCommitmentNotesModalOpen(true);
                    }}
                  >
                    {i18n.t(commitmentFieldValue)}
                  </span>
                ) : (
                  i18n.t(commitmentFieldValue)
                )}
              </RACTableCell>
              <RACTableCell>
                {pastDueCustomer.activeAgreementCount}
              </RACTableCell>
              <RACTableCell>
                {pastDueCustomer.myStoreAgreementCount}
              </RACTableCell>
              <RACTableCell>
                {pastDueCustomer?.autoPayFlag?.toUpperCase() === 'Y'
                  ? pastDueCustomer?.autoPayFlag
                  : ''}
              </RACTableCell>
              {isMXAccountManagement && (
                <RACTableCell>${NSFChargebackAmt}</RACTableCell>
              )}
              <RACTableCell>
                {validateFieldValue(
                  pastDueCustomer.sentLetterFlag?.toUpperCase() === 'Y'
                    ? i18n.t(pastDueCustomer.letterType?.description)
                    : ''
                )}
              </RACTableCell>
              <RACTableCell>{pastDueCustomer.communicationsTotal}</RACTableCell>
              <RACTableCell>{pastDueCustomer.communicationsToday}</RACTableCell>
            </>
          </RACTableRow>
        );
      })}
    </>
  );

  const renderTableContent = () => {
    if (isPastDueListEmpty) return <></>;

    return renderTableContentFilled();
  };

  const formatAllFields = (field: string[]) =>
    field.includes(ALL_OPTION) ? [] : field;

  const createFilterPayload = (filter: Filter) => {
    return {
      ...filter,
      storeNumber: getSelectedStore(),
      daysPastDue: formatAllFields(filter.daysPastDue),
      bestTimeToCall: formatAllFields(filter.bestTimeToCall),
      commitmentStatus: formatAllFields(filter.commitmentStatus),
      communicationType: formatAllFields(filter.communicationType),
      language: formatAllFields(filter.language),
    };
  };

  const fetchPastDueList = (resetPastDueList: boolean) => {
    if (initialCallToken?.current) {
      initialCallToken.current?.cancel();
    }
    initialCallToken.current = getCancelTokenSource();

    setHasApiError(false);
    setPastDueListLoading(true);
    getPastDueList(
      createFilterPayload(filter),
      offset,
      pastDueListApiLimit,
      initialCallToken.current?.token
    )
      .then((response: PastDueCustomerResponse[]) => {
        let responseToUse;
        if (response?.length) {
          responseToUse = response.map((pastDueItem) => {
            if (!pastDueItem.commitment) {
              return pastDueItem;
            }
            return {
              ...pastDueItem,
              commitment: {
                ...pastDueItem.commitment,
                commitmentStatus: pastDueItem.commitment.commitmentActualStatus,
              },
            };
          });
        }
        setFilteredPastDueList(responseToUse || [], resetPastDueList);
        setPastDueListLoading(false);
        setReloadPastDueList(false);
      })
      .catch((err) => {
        if (!err.__CANCEL__) {
          setHasApiError(true);
          setFilteredPastDueList([], resetPastDueList);
          setPastDueListLoading(false);
          setReloadPastDueList(false);
        }
      });
  };

  useEffect(() => {
    onCustomerSelectChanged(false);
  }, []);

  useEffect(() => {
    if (!storeConfigLoaded) return;
    if (!reloadPastDueList) return;
    setFilteredPastdue([]);
    setFilteredPastDueList([], true);

    if (offset === INITIAL_OFFSET) {
      fetchPastDueList(true);
    } else {
      setOffset(INITIAL_OFFSET);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadPastDueList, storeConfigLoaded]);

  useEffect(() => {
    const filteredData = applySubFilter(pastDue, subFilter);
    setFilteredPastdue(filteredData || []);
    if (!filteredData || !filteredData.length) {
      setFilterName(subFilter);
    } else {
      setFilterName('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subFilter, pastDue]);

  useEffect(() => {
    setSelected([]);
    setSelectedCustomerIds([]);
    setSelectCustomerName('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subFilter]);

  useEffect(() => {
    if (!selectedCustomerIds.length) {
      setSelected(selectedCustomerIds);
    }
  }, [selectedCustomerIds]);

  useEffect(() => {
    if (!storeConfigLoaded) return;
    clearPastDueList();
    if (offset === INITIAL_OFFSET && !isFirstFetch) {
      fetchPastDueList(true);
      setIsFirstFetch(false);
    }
    setOffset(INITIAL_OFFSET);
  }, [filter, storeConfigLoaded]);

  useEffect(() => {
    if (!storeConfigLoaded) return;
    const reloadPastDueList = offset === INITIAL_OFFSET;
    fetchPastDueList(reloadPastDueList);
    setIsFirstFetch(false);
  }, [offset, storeConfigLoaded, pastDueListApiLimit]);

  /*
  Increment the offset.
  Fetch is handled in the useEffect that listens on the offset.
  */
  const fetchNextPage = () => {
    /*
    fetchNextPage is used by infinite scroll component
    the first fetch is handled by our component, therefore we are not letting the
    infinite scroll to trigger the first request.
    Handles the case when you apply the filters
    (offset set to 0 -> request is triggered, but infinite scroll is also triggering a request, because its data length is 0)
    */
    if (!filteredPastDue || filteredPastDue.length < 1) return;
    setOffset(offset + pastDueListApiLimit);
  };

  return (
    <div
      className={clsx(classes.customerListWrapper)}
      data-testid={customerListWrapperTestId}
    >
      {isCommitmentNotesModalOpen && selectedCommitment && (
        <CommitmentNotesModal
          commitment={selectedCommitment}
          onClose={handleCommitmentNotesModalClose}
        />
      )}
      <InfiniteScroll
        next={fetchNextPage}
        dataLength={filteredPastDue?.length || 0}
        hasMore={hasMore}
        height={500}
        loader={loading && filteredPastDue?.length ? <Loader /> : null}
      >
        <ApiStateWrapper
          // show loading only for the first request
          loading={(!storeConfigLoaded || loading) && filteredPastDue?.length === 0}
          // show error only if the first request fails
          hasApiError={hasApiError && filteredPastDue.length === 0}
          response={filteredPastDue}
          noItemAdditionalText={
            filterName ? ` ${t('for')} '${filterName}' ${'filter'}` : ''
          }
          successContent={
            <RACTable
              renderTableHead={renderTableHead}
              renderTableContent={renderTableContent}
              stickyHeader
            />
          }
          classes={{
            loader: classes.contentHeight,
            apiError: classes.contentHeight,
            noItems: classes.contentHeight,
          }}
        />
      </InfiniteScroll>
    </div>
  );
};
